// extracted by mini-css-extract-plugin
export default {"container":"pin-number_container__xSE4q","number":"pin-number_number__YZbKH"};